// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"b35f79391b541d75cbda","293":"2f009d74d152772039a4","518":"580c9884ccdbc832e19a","779":"433f3344350e76eb4db1"}[chunkId] + ".js";
};